import React, { useEffect, useState } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  NotificationList,
  useQuantaFormikContext,
  Grid,
  GridItem
} from 'quanta-ui';
import {
  POLICY_EXPIRY_DATE,
  PREVIOUS_POLICY_DROPDOWN_DETAILS,
} from '../../../queries';
import {Loading} from 'quanta-flows/modules/layout';
import { useLazyQuery, useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {Error} from 'quanta-flows/modules/layout';
export default function PreviousInsurance({
  productCode,
  productName,
  lobCode,
  lobName,
  quoteNumber,
  setPolicyTermList,
  modify,
}) {

  const { values, setFieldValue } = useQuantaFormikContext();
  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  const [alerts, setAlerts] = useState([]);
  useEffect(()=>{
  //  if(values.isRegNoVerified === false){
   setFieldValue(`policyCoverType`, '');
   setFieldValue(`policyTenure`, '');
   setFieldValue(`policyTenureValue`, '');
   setFieldValue(`policyStartDate`, '');
   setFieldValue(`policyExpiryDate`, '');
   setFieldValue(`totalClaimCount`, '');
   setFieldValue(`totalClaimCountValue`, '');
   setFieldValue(`noOfClaimsOneYear`, '');
   setFieldValue(`noOfClaimsTwoYears`, '');
   setFieldValue(`noOfClaimsThreeYears`, '');
   setFieldValue(`totalClaimAmount`, '');
   setFieldValue(`previousYearNCBSlab`, '');
//  }
},[]);

  const { loading, data: dropDownDetails } = useQuery(
    PREVIOUS_POLICY_DROPDOWN_DETAILS,
    {
      fetchPolicy: 'cache-first',
      variables: {
        productCode: productCode,
      },
      onError: (err) => {
        setAlerts([
          {
            header: 'No dropdown details',
            id: 1,
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{err.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      onCompleted: (data) => {
        setPolicyTermList(data);
      },
    },
  );

  useEffect(()=> {
    if(loading) {
      setFieldValue(`isPrevInsuranceLoading`,true);
    }
    else{
      setFieldValue(`isPrevInsuranceLoading`,false);
    }
  },[loading])

  const [
    getPolicyExpiryDate,
    {
      loading: loadingPolicyExpiryDate,
      error: errorPolicyExpiryDate,
    },
  ] = useLazyQuery(POLICY_EXPIRY_DATE, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setFieldValue(
        'policyExpiryDate',
        `${data?.policyExpireDate?.expireDate}`,
      );
    },
  });

  useEffect(() => {
    if (loading) {
      setFieldValue(`isPrevInsuranceLoading`, true);
    } else {
      setFieldValue(`isPrevInsuranceLoading`, false);
    }
  }, [loading]);

  if (loading || loadingPolicyExpiryDate) {
    return <Loading />;
  }
  if (errorPolicyExpiryDate) {
    return <Error error={errorPolicyExpiryDate} />;
  }
  const { PRD_PreviousPolicyTypeList, PRD_PreviousPolicyTermList } =
    dropDownDetails;

  let grid_data = [
    {
      type: 'select',
      size: 'large',
      label: values?.businessTypeValue?.toLowerCase() ==='used car' ? (
        <>
          Cover Type
        </>
      ) :(
        <>
          Cover Type<Text severity="error"> *</Text>
        </>
      ),
      name: 'policyCoverType',
      disabled: (values?.quotationNo !== '' && !modify )
       || values?.businessTypeValue?.toLowerCase() ===
      'used car', 
      data: PRD_PreviousPolicyTypeList &&
       PRD_PreviousPolicyTypeList?.length>0
        ? [
            ...PRD_PreviousPolicyTypeList.map((policyCoverType) => {
              return {
                label: policyCoverType.value
                  ? `${policyCoverType.value}`
                  : '',
                value: policyCoverType.code
                  ? `${policyCoverType.code}`
                  : '',
              };
            }),
          ]
        : [],
    },
    // {
    //   type: 'select',
    //   size: 'large',
    //   label: (
    //     <>
    //       Policy Tenure<Text severity="error"> *</Text>
    //     </>
    //   ),
    //   name: 'policyTenure',
    //   disabled: values?.quotationNo !== '',
    //   data: PRD_PreviousPolicyTermList && PRD_PreviousPolicyTermList?.length>0
    //     ? [
    //         ...PRD_PreviousPolicyTermList.map((policyCoverType) => {
    //           return {
    //             label: policyCoverType.value
    //               ? `${policyCoverType.value}`
    //               : '',
    //             value: policyCoverType.code
    //               ? `${policyCoverType.code}`
    //               : '',
    //           };
    //         }),
    //       ]
    //     : [],
    //   onDataChange: (val, setFieldValue) => {
    //     setFieldValue(
    //       `policyTenureValue`,
    //       PRD_PreviousPolicyTermList?.find(
    //         (pT) => pT?.code?.toLowerCase() === val?.toLowerCase(),
    //       )?.value,
    //     );
    //     if(values.isPrevClaimsAvailable === false )
    //     {
    //       // console.log("inside if : values.isPrevClaimsAvailable : " ,values.isPrevClaimsAvailable);
    //       setFieldValue( `noOfClaimsOneYear`,  '');
    //       setFieldValue(`noOfClaimsTwoYears`,  '');
    //       setFieldValue(`noOfClaimsThreeYears`,  '');
    //       setFieldValue(`totalClaimAmount`,'');
    //       setFieldValue( `totalClaimCount`, '',);
    //     }
    //     if (val?.toString()?.toLowerCase() === 'long term') {
    //       setFieldValue(`policyExpiryDate`, '');
    //     }
    //     if (
    //       val?.toString()?.toLowerCase() === 'annual' &&
    //       values?.policyStartDate
    //     ) {
    //       getPolicyExpiryDate({
    //         variables: {
    //           input: {
    //             startDate: values?.policyStartDate,
    //           },
    //         },
    //       });
    //     }
    //   },
    // },
    {
      type: 'date',
      size: 'large',
      label: values?.businessTypeValue?.toLowerCase() ==='used car' ? (
        <>
          Policy Expiry Date
        </>
      ) : (
        <>
          Policy Expiry Date <Text severity="error"> *</Text>
        </>
      ),
      disabled: (values?.quotationNo !== '' && !modify )
       || values?.businessTypeValue?.toLowerCase() ===
      'used car',
      name: 'policyExpiryDate',
      onDataChange: async (val,setFieldValue) => {
        setFieldValue(
          `policyStartDate`,
          moment(val,"DD/MM/YYYY").subtract(1, 'year').add(1,'days').format('DD/MM/YYYY')
        );
       
      },
    },
    {
      type: 'date',
      size: 'large',
      label: values?.businessTypeValue?.toLowerCase() ==='used car' ? (
        <>
          Policy Start Date
        </>
      ) : (
        <>
          Policy Start Date <Text severity="error"> *</Text>
        </>
      ),
    disabled: (values?.quotationNo !== '' && !modify )
      || values?.businessTypeValue?.toLowerCase() ==='used car',
      name: 'policyStartDate',
     
    },
  
  ].filter((d) => d);

  return (
    <div>
      {/* <Paper> */}
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        title={
          <Grid
            flow={'cols'}
            repeat={inputColSpans}
            className="w-full"
          >
            <GridItem
              colSpan={
                inputColSpans === noOfColsMobile ? inputColSpans : 1
              }
              className="w-full"
            >
              <Text type={'title'}>Previous Policy</Text>
            </GridItem>
            <GridItem
              colSpan={
                inputColSpans === noOfColsMobile ? inputColSpans : 2
              }
              className="full"
            >
              <>
                {/* {values?.isRegNoVerified === false || 
                  (values?.isPrevInsuranceAvailable === false && (
                    <Text
                      type={'normal'}
                      severity={'error'}
                      className="flex space-x-2"
                    >
                      <span>
                        <FontAwesomeIcon icon={faExclamation} />
                      </span>
                      <span>
                        We couldn't find any previous policy for your
                        vehicle, please enter manually
                      </span>
                    </Text>
                  ))}
                {values?.isRegNoVerified &&
                  values?.isPrevInsuranceAvailable && (
                    <Text
                      type={'normal'}
                      className={'flex space-x-2'}
                    >
                      <Text severity={'success'}>
                        <FontAwesomeIcon icon={faCheck} />
                      </Text>
                      <Text severity={'dark'}>
                        We have found below previous policy details
                        for your vehicle
                      </Text>
                    </Text>
                  )} */}
              </>
            </GridItem>
          </Grid>
        }
        size="large"
        gapX={10}
      />
      {/* </Paper> */}
      <NotificationList {...{ items: alerts }} />
    </div>
  );
}
